/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-13 09:53:09
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbSettingsPad {
    /**
     * 根据配置枚举查询对于配置
     */
    export var GetTbSettings = (body: any): Promise<any> => {
        return Get(`/api/TbSettings/GetTbSettings`, body);
    };
    /**
     * 修改配置
     */
    export var PutTbSettings = (body: any): Promise<any> => {
        return Put(`/api/TbSettings/PutTbSettings`, body);
    };
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbSettingsPad.ts